/* CELEGYA - un clic sur un titre de menu qui a un sous-menu (ex. Boutique) ouvre le menu deroulant au lieu de changer de page */
document.addEventListener('click', function (e) {
  var a = e.target.closest('.menu-list__trigger > .menu-list__link');
  if (!a) return;
  e.preventDefault();
  e.stopPropagation();
  var b = a.parentElement.querySelector('.menu-list__disclosure');
  if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
}, true);
